import * as actionTypes from "./actionTypes";

export const addNewNonSaleableReturnAction = (nonSaleableReturnData) => {
  return { type: actionTypes.ADD_NEW_NON_SALEABLE_RETURN, nonSaleableReturnData };
};

export const addNewNonSaleableReturnSuccessAction = (nonSaleableReturnData) => {
  return { type: actionTypes.ADD_NEW_NON_SALEABLE_RETURN_SUCCESS, nonSaleableReturnData };
};

export const editNonSaleableReturnAction = (nonSaleableReturnData) => {
  return { type: actionTypes.EDIT_NON_SALEABLE_RETURN, nonSaleableReturnData };
};

export const editNonSaleableReturnSuccessAction = (nonSaleableReturnData) => {
  return { type: actionTypes.EDIT_NON_SALEABLE_RETURN_SUCCESS, nonSaleableReturnData };
};

export const deleteNonSaleableReturnAction = (nonSaleableReturnData) => {
  return { type: actionTypes.DELETE_NON_SALEABLE_RETURN, nonSaleableReturnData };
};

export const deleteNonSaleableReturnSuccessAction = (nonSaleableReturnData) => {
  return { type: actionTypes.DELETE_NON_SALEABLE_RETURN_SUCCESS, nonSaleableReturnData };
};
